/**
 * PostHog User Identification
 *
 * Automatically identifies users in PostHog when they sign in with Clerk
 * Resets identification when users sign out
 *
 * This component gracefully handles missing PostHog configuration
 * by checking if PostHog is enabled before attempting to identify users.
 */

import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'
import { posthog, isPostHogEnabled } from '@/lib/posthog'

export function PostHogIdentify() {
  const { user, isSignedIn } = useUser()

  useEffect(() => {
    // Gracefully skip if PostHog is not configured
    if (!isPostHogEnabled()) {
      return
    }

    try {
      if (isSignedIn && user) {
        // Identify user with Clerk user ID
        posthog.identify(user.id, {
          email: user.primaryEmailAddress?.emailAddress,
          name: user.fullName || user.username || undefined,
          // Add any other user properties you want to track
          created_at: user.createdAt?.toISOString(),
        })

        console.log('[PostHog] User identified:', user.id)
      } else {
        // Reset identity when user signs out
        posthog.reset()
        console.log('[PostHog] User identity reset')
      }
    } catch (error) {
      // Silently fail if PostHog is not properly initialized
      console.warn('[PostHog] Failed to identify user:', error)
    }
  }, [isSignedIn, user])

  return null // This component doesn't render anything
}
